import { styled } from '@spazious/dollhouse-theme';

import { ButtonBase } from '../Button/index.js';
import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

type ToolbarAlignment =
  | 'top-start'
  | 'top-center'
  | 'top-end'
  | 'left-start'
  | 'left-center'
  | 'left-end'
  | 'bottom-start'
  | 'bottom-center'
  | 'bottom-end'
  | 'right-start'
  | 'right-center'
  | 'right-end';

const aligmentMapping: Record<ToolbarAlignment, string> = {
  'top-start': `
    top: var(--spacing-padding);
    left: var(--spacing-padding);
  `,
  'top-center': `
    top: var(--spacing-padding);
    left: 50%;
    transform: translateX(-50%);
  `,
  'top-end': `
    top: var(--spacing-padding);
    right: var(--spacing-padding);
  `,
  'left-start': `
    top: var(--spacing-padding);
    left: var(--spacing-padding);
  `,
  'left-center': `
    top: 50%;
    left: var(--spacing-padding);
    transform: translateY(-50%);
  `,
  'left-end': `
    bottom: var(--spacing-padding);
    left: var(--spacing-padding);
  `,
  'bottom-start': `
    bottom: var(--spacing-padding);
    left: var(--spacing-padding);
  `,
  'bottom-center': `
    bottom: var(--spacing-padding);
    left: 50%;
    transform: translateX(-50%);
  `,
  'bottom-end': `
    bottom: var(--spacing-padding);
    right: var(--spacing-padding);
  `,
  'right-start': `
    top: var(--spacing-padding);
    right: var(--spacing-padding);
  `,
  'right-center': `
    top: 50%;
    right: var(--spacing-padding);
    transform: translateY(-50%);
  `,
  'right-end': `
    bottom: var(--spacing-padding);
    right: var(--spacing-padding);
  `,
};

export type ToolBarElement = FlexElement;

export interface ToolBarProps extends FlexProps {
  alignment?: ToolbarAlignment;
}

export const ToolBar = styled(Flex)
  .attrs({
    inline: true,
    row: true,
  })
  .withConfig({
    shouldForwardProp: (prop) => !['alignment'].includes(prop),
    displayName: 'ToolBar',
  })<ToolBarProps>`
  position: absolute;
  z-index: 10;
  gap: calc(var(--spacing-gap) * 2);
  // Set the alignment of the ToolBar
  ${({ alignment = 'top-center' }) => aligmentMapping[alignment]}
  ${ButtonBase} {
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  }
  & > * {
    pointer-events: auto;
  }
`;

export default ToolBar;
